import React from "react";
import DropDown from "./DropDown";
import { useAppContext } from "../../helpers/account-context";
import { cleanAvailableTypes } from "../../helpers/helper";

const TypeDropdown = (props) => {
  const { filters, onChangeFilters } = props;
  // https://codepen.io/smithsuth/pen/VvYzZP
  const {  initedData: {enabledTypes, hiddenFilters}, account: { location_types }, getLocale } = useAppContext()
  const isHidden = !!hiddenFilters && (hiddenFilters.indexOf('types') >= 0 || hiddenFilters.indexOf('all') >= 0);

  if(isHidden) return null;
     
  const options = cleanAvailableTypes(location_types, enabledTypes);
  if(!options || options.length === 0) return null;
  const selectedType = options.find((lt) => (lt.value === filters.location_type_id));

  return (
    <DropDown
      className="cbmap-dropdown-type"
      title={selectedType ? selectedType.label : getLocale("location_type")}
      items={options}
      selectedItems={[filters.location_type_id]}
      isMulti={false}
      onChange={(newTypes) => {
        return onChangeFilters({ 
          ...filters, 
          location_type_id: newTypes && newTypes.length > 0 ? newTypes[0] : null 
        })
      }}
    />
  )
};

export default TypeDropdown;
